import { useState, useEffect } from "react";
import cargandoCard from "../../components/cargando-card";
import NoContentCard from "../../components/no-content-card";
import { actualizarPreguntasChecklist, modificarChecklist, obtenerInfoChecklist, obtenerPreguntasChecklist } from "../../api/api-checklist";
import { useHistory, useLocation } from "react-router-dom";
import {
    ESTILO_BOTON_DOWN,
    ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_MODAL_ACEPTAR,
    ESTILO_BOTON_UP,
    ESTILO_INPUT_GENERICO, ESTILO_ROTATE_180, ESTILO_ROTATE_45,
    ESTILO_SECCION_BOTON_DOWN,
    ESTILO_SECCION_BOTON_UP
} from "../../utils/const/estilos-const";
import { obtenerListaTipoChecklist } from "../../api/tipo-checklist";
import Select from "react-select";
import { ArrowDownCircle, ArrowUpCircle, CheckSquare, ChevronLeft, ChevronsLeft, Plus, RefreshCcw, Save, Trash, XSquare, } from "feather-icons-react/build/IconComponents";
import {
    INT_ORIENTACION_RESPUESTAS,
    INT_PREGUNTA_COMENTARIO, INT_PREGUNTA_FIRMA, INT_PREGUNTA_IMAGEN,
    INT_PREGUNTA_SELECCION_MULTIPLE, INT_PREGUNTA_SELECCION_SIMPLE,
    STRING_PREGUNTA_COMENTARIO, STRING_PREGUNTA_FIRMA, STRING_PREGUNTA_IMAGEN,
    STRING_PREGUNTA_SELECCION_MULTIPLE, STRING_PREGUNTA_SELECCION_SIMPLE
} from "../../utils/const/tipo-pregunta-const";
import { obtenerListaTipoOpcionesRespuesta } from "../../api/configuracion";
import DropdownPregunta from "../../components/dropdown-pregunta-component";
import FooterPregunta from "../../components/footer-pregunta-component";
import { crearSeccion } from "../../api/seccion";
import { crearPreguntaSeccion } from "../../api/preguntas-seccion";
import { obtenerListaIconos } from "../../api/gestionar-imagenes";
import { deshabilitarOpcionRespuestaPregunta, guardarOpcionRespuestaPregunta, restaurarOpcionRespuestaPregunta } from "../../api/opciones-respuesta-pregunta";
import { INT_QUERY_DELETE, INT_QUERY_UPDATE } from "../../utils/const/int-const";
import { TRUE } from "../../utils/const/bool-const";
import { useTranslation } from "react-i18next";
import SwitchComponent from "../../components/switch";

export default function PreguntasChecklist() {

    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [checklistSelected, setChecklistSelected] = useState({});
    const [noContent, setNoContent] = useState(false);
    const [listaSecciones, setListaSecciones] = useState([]);
    const [isHoveredBackButton, setIsHoveredBackButton] = useState(false);

    const [listaTipoChecklist, setListaTipoChecklist] = useState([]);
    const [tipoChecklistSelected, setTipoChecklistSelected] = useState(null);

    const [listaOpcionesRespuesta, setListaOpcionesRespuesta] = useState([]);
    const [listaIconos, setListaIconos] = useState(null);

    const [manejoDefensivo, setManejoDefensivo] = useState(false);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);
            checklistSelected.id = data.id;
            const infoChecklist = await obtenerInfoChecklist(checklistSelected);
            // console.log('infoChecklist');
            // console.log(infoChecklist);
            setChecklistSelected(infoChecklist);
            if (infoChecklist === null) {
                setNoContent(true);
                return;
            }

            if (data.manejoDefensivo === TRUE) {
                setManejoDefensivo(true);
            }

            const listaPivoteSeccion = await obtenerPreguntasChecklist(checklistSelected);
            setListaSecciones(listaPivoteSeccion);

            const listaTC = await obtenerListaTipoChecklist(true);
            setListaTipoChecklist(listaTC);
            if (infoChecklist.idTipoChecklist !== null) {
                const tipoCheckLis = listaTC.find(e => e.value === infoChecklist.idTipoChecklist);
                setTipoChecklistSelected(tipoCheckLis !== undefined ? tipoCheckLis : null);
            }

            const optRespuesta = await obtenerListaTipoOpcionesRespuesta(true);
            // console.log('optRespuesta');
            // console.log(optRespuesta);
            setListaOpcionesRespuesta(optRespuesta);

            const listaIco = await obtenerListaIconos();
            // console.log('listaIco');
            // console.log(listaIco);
            let listaIconosChecklist = [];
            for (let i = 0; i < listaIco.length; i++) {
                const element = listaIco[i];
                let obj = {};
                obj.value = element.id;
                obj.label = element.descripcion;
                obj.url = element.url;
                listaIconosChecklist.push(obj);
            }
            setListaIconos(listaIconosChecklist);

            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
            setNoContent(true);
        }
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const handleInputChange = (event) => {
        // console.log('handleInputChange');
        const { name, value } = event.target;
        // console.log(name);
        // console.log(value);
        setChecklistSelected({ ...checklistSelected, [name]: value });
    };

    const validarActualizar = () => {
        try {
            // console.log('validar');
            // console.log(elemento);
            let error = "";
            if (checklistSelected.nombre === undefined || checklistSelected.nombre === null || String(checklistSelected.nombre).trim().length === 0) {
                error = error + t('alert_nombre_es_requerido') + "\n";
            }
            if (checklistSelected.nota === undefined || checklistSelected.nota === null) {
                checklistSelected.nota = "";
            }
            if (String(error).length > 0) {
                alert(error);
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    };

    const onPressActualizar = async () => {
        try {
            const validarAct = validarActualizar();
            if (validarAct === false) {
                return;
            }
            checklistSelected.idTipoChecklist = tipoChecklistSelected !== null ? tipoChecklistSelected.value : null;
            const actualizo = await modificarChecklist(checklistSelected);
            if (actualizo === false) {
                alert('No se pudo actualizar, intente nuevamente');
                return;
            }
            if (actualizo === true) {
                alert('Se actualizo correctamente');
                handleAtrasClick();
            }
        } catch (err) {
            console.log('onPressActualizar err');
            console.log(err);
            alert('No se pudo actualizar, intente nuevamente');
            return;
        }
    };

    const handleAddSection = async () => {
        // console.log('checklistSelected');
        // console.log(checklistSelected);
        const seccion = await crearSeccion({ idChecklist: checklistSelected.id, });
        // console.log('seccion');
        // console.log(seccion);
        if (seccion.creado === true) {
            setListaSecciones((prevlistaSecciones) => [...prevlistaSecciones, { id: seccion.id, query: INT_QUERY_UPDATE, }]);
        }
        if (seccion.creado === false) {
            alert(t('alert_no_se_pudo_procesar_intente_nuevamente'));
        }
    };

    const handleAddPregunta = async (tipoPregunta, index) => {
        // console.log('handleAddPregunta');
        // console.log('checklistSelected');
        // console.log(checklistSelected);
        // console.log(tipoPregunta);
        // console.log(listaSecciones);
        // console.log(listaSecciones[index]);
        let objEnviar = {};
        objEnviar.idChecklist = checklistSelected.id;
        objEnviar.idSeccion = listaSecciones[index].id;
        objEnviar.urlIcon = null;
        objEnviar.tipoPregunta = tipoPregunta;
        objEnviar.codigoPregunta = "";
        objEnviar.tituloPregunta = "";
        const crearPregunta = await crearPreguntaSeccion(objEnviar);
        // console.log('crearPregunta');
        // console.log(crearPregunta);
        if (crearPregunta.creado === false) {
            alert(t('alert_no_se_pudo_procesar_intente_nuevamente'));
            return;
        }
        const newListaSecciones = [...listaSecciones];
        if (newListaSecciones[index].preguntas === undefined) {
            newListaSecciones[index].preguntas = [];
        }
        switch (tipoPregunta) {
            case INT_PREGUNTA_SELECCION_SIMPLE:
                newListaSecciones[index].preguntas.push({
                    id: crearPregunta.id,
                    tituloPregunta: "",
                    opcionesRespuestasHabilitadas: [],
                    opcionesRespuestasDeshabilitadas: [],
                    multiple: false,
                    tipo: STRING_PREGUNTA_SELECCION_SIMPLE,
                    idTipo: INT_PREGUNTA_SELECCION_SIMPLE,
                    urlIcon: null,
                    query: INT_QUERY_UPDATE,
                    manejoDefensivo: false,
                });
                break;
            case INT_PREGUNTA_SELECCION_MULTIPLE:
                newListaSecciones[index].preguntas.push({
                    id: crearPregunta.id,
                    tituloPregunta: "",
                    opcionesRespuestasHabilitadas: [],
                    opcionesRespuestasDeshabilitadas: [],
                    multiple: true,
                    tipo: STRING_PREGUNTA_SELECCION_MULTIPLE,
                    idTipo: INT_PREGUNTA_SELECCION_MULTIPLE,
                    urlIcon: null,
                    query: INT_QUERY_UPDATE,
                });
                break;
            case INT_PREGUNTA_FIRMA:
                newListaSecciones[index].preguntas.push({
                    id: crearPregunta.id,
                    tituloPregunta: "",
                    multiple: false,
                    tipo: STRING_PREGUNTA_FIRMA,
                    idTipo: INT_PREGUNTA_FIRMA,
                    urlIcon: null,
                    query: INT_QUERY_UPDATE,
                });
                break;
            case INT_PREGUNTA_IMAGEN:
                newListaSecciones[index].preguntas.push({
                    id: crearPregunta.id,
                    tituloPregunta: "",
                    multiple: false,
                    tipo: STRING_PREGUNTA_IMAGEN,
                    idTipo: INT_PREGUNTA_IMAGEN,
                    urlIcon: null,
                    query: INT_QUERY_UPDATE,
                });
                break;
            case INT_PREGUNTA_COMENTARIO:
                newListaSecciones[index].preguntas.push({
                    id: crearPregunta.id,
                    tituloPregunta: "",
                    multiple: false,
                    tipo: STRING_PREGUNTA_COMENTARIO,
                    idTipo: INT_PREGUNTA_COMENTARIO,
                    urlIcon: null,
                    query: INT_QUERY_UPDATE,
                });
                break;
        }
        setListaSecciones(newListaSecciones);
    };

    const handleInputChangeSection = (event, index) => {
        // console.log('handleInputChangeSection');
        // console.log(listaSecciones);
        const { name, value } = event.target;
        // console.log(name);
        // console.log(value);
        const newListaSecciones = [...listaSecciones];
        newListaSecciones[index] = {
            ...newListaSecciones[index],
            [name]: value,
        };
        setListaSecciones(newListaSecciones);
    };

    const handleInputChangePregunta = (event, indexSeccion, indexPregunta) => {
        // console.log('handleInputChangeSection');
        // console.log('indexSeccion->' + indexSeccion);
        // console.log('indexPregunta->' + indexPregunta);
        const { name, value } = event.target;
        // console.log(name);
        // console.log(value);
        const newListaSecciones = [...listaSecciones];
        newListaSecciones[indexSeccion].preguntas[indexPregunta] = {
            ...newListaSecciones[indexSeccion].preguntas[indexPregunta],
            [name]: value,
        };
        // console.log('newListaSecciones');
        // console.log(newListaSecciones);
        setListaSecciones(newListaSecciones);
    };

    const renderPreguntasSeccion = (indexSeccion) => {
        try {
            // console.log('renderPreguntasSeccion');
            // console.log(listaSecciones);
            // console.log(listaSecciones[indexSeccion]);
            const arrowStyle = {
                width: "10%",
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
            };
            const styleRow = {
                marginTop: 5,
                boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.25)",
                display: 'flex',
                flexDirection: 'row'
            };
            if (listaSecciones[indexSeccion].preguntas !== undefined && listaSecciones[indexSeccion].preguntas.length > 0) {
                return listaSecciones[indexSeccion].preguntas.map((pregunta, indexPregunta) => {
                    switch (pregunta.idTipo) {
                        case INT_PREGUNTA_SELECCION_SIMPLE:
                            return renderPreguntaSimple(indexSeccion, pregunta, indexPregunta, arrowStyle, styleRow);
                        case INT_PREGUNTA_FIRMA:
                            return renderPreguntaFirma(indexSeccion, pregunta, indexPregunta, arrowStyle, styleRow);
                        case INT_PREGUNTA_IMAGEN:
                            return renderPreguntaImagen(indexSeccion, pregunta, indexPregunta, arrowStyle, styleRow);
                        case INT_PREGUNTA_COMENTARIO:
                            return renderPreguntaComentario(indexSeccion, pregunta, indexPregunta, arrowStyle, styleRow);
                    }
                });
            }
        } catch (err) {
            console.log('renderPreguntasSeccion err');
            console.log(err);
        }
    };

    const renderSections = () => {
        try {
            // console.log('renderSections');
            return listaSecciones.map((section, indexSeccion) => {
                // console.log('section');
                // console.log(section);
                if (section.query === INT_QUERY_UPDATE) {
                    return (
                        <div
                            className="rounded shadow-2xl bg-white mb-4 px-4 py-4"
                            key={indexSeccion}
                        >
                            <div className="flex direction-row" >
                                <input
                                    id="nombreSeccion"
                                    name="nombreSeccion"
                                    type="text"
                                    value={section.nombreSeccion}
                                    onChange={e => { handleInputChangeSection(e, indexSeccion); }}
                                    className={ESTILO_INPUT_GENERICO}
                                    required
                                    maxLength={255}
                                    placeholder={t('label_nombre_seccion')}
                                />
                                <DropdownPregunta
                                    handleAddPregunta={handleAddPregunta}
                                    indexSeccion={indexSeccion}
                                />
                                {renderUpDownButtonSecciones(indexSeccion)}
                            </div>
                            <br />
                            <div className="pl-4">
                                <label className="font-bold" >{t('label_preguntas')}</label>
                                {renderPreguntasSeccion(indexSeccion)}
                            </div>
                            <hr />
                            <div className="flex justify-between mt-2">
                                <label>{t('label_seccion_nro')}: {indexSeccion}</label>
                                <button
                                    type="button"
                                    className={`${ESTILO_BOTON_GENERAL_ACEPTAR} flex items-center`}
                                    onClick={() => handleEliminarSeccion(indexSeccion)}
                                    title={t('titulo_eliminar_seccion')}
                                >
                                    <Trash className={`mr-2 ${ESTILO_ROTATE_45}`} />
                                    {t('btn_eliminar_seccion')}
                                </button>
                            </div>
                        </div>
                    );
                }
                return (<div></div>);
            });
        } catch (err) {
            console.log("renderSections err");
            console.log(err);
            return <div>{JSON.stringify(err)}</div>;
        }
    };

    const toggleSwitchManejoDefensivo = (indexSeccion, indexPregunta) => {
        let newListaSecciones = [...listaSecciones];
        // console.log('toggleSwitchManejoDefensivo', newListaSecciones);
        // console.log('indexSeccion', indexSeccion);
        // console.log('indexPregunta', indexPregunta);
        newListaSecciones[indexSeccion].preguntas[indexPregunta].manejoDefensivo = !newListaSecciones[indexSeccion].preguntas[indexPregunta].manejoDefensivo;
        setListaSecciones(newListaSecciones);
    };

    const renderPreguntaSimple = (indexSeccion, pregunta, indexPregunta, arrowStyle, styleRow) => {
        try {
            // console.log('renderPreguntaSimple indexSeccion', indexSeccion);
            // console.log('renderPreguntaSimple pregunta', pregunta);
            // console.log('renderPreguntaSimple indexPregunta', indexPregunta)
            if (pregunta.query === INT_QUERY_UPDATE) {
                const isOn = pregunta.manejoDefensivo !== undefined && (pregunta.manejoDefensivo === true || pregunta.manejoDefensivo === 1) ? true : false;
                // const isOn = false;
                return (
                    <div
                        style={styleRow}
                    >
                        {renderUpDownButton(arrowStyle, indexSeccion, indexPregunta)}
                        <div
                            style={{
                                width: '80%'
                            }}
                        >
                            <div className="flex flex-row w-full" >
                                {renderRowIconoPregunta(indexSeccion, pregunta, indexPregunta)}
                            </div>
                            <FooterPregunta
                                indexPregunta={indexPregunta}
                                indexSeccion={indexSeccion}
                                handleEliminarPregunta={handleEliminarPregunta}
                            />
                        </div>

                        {manejoDefensivo === true &&
                            <div
                                style={{
                                    width: '50px',
                                }}
                            >
                                <label className="flex pl-4 font-bold">{t('label_manejo_defensivo')}</label>
                                <div
                                    style={{
                                        paddingTop: '12px',
                                    }}
                                >
                                    <div
                                        className={`flex items-center bg-gray-300 rounded-full p-1 cursor-pointer ${isOn ? 'bg-green-400' : 'bg-gray-300'}`}
                                        onClick={() => { toggleSwitchManejoDefensivo(indexSeccion, indexPregunta); }}
                                    >
                                        <div
                                            className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${isOn ? 'translate-x-6' : ''}`}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                );
            }
            return (<div></div>);
        } catch (err) {
            console.log('renderPreguntaSimple err');
            console.log(err);
        }
    };

    const renderRowIconoPregunta = (indexSeccion, pregunta, indexPregunta) => {
        try {
            // console.log('renderRowIconoPregunta');
            // console.log(pregunta);
            return (
                <>
                    <div style={{
                        width: "29%",
                        flexDirection: "column",
                        display: "flex",
                    }}
                    >
                        <Select
                            options={listaIconos}
                            isSearchable={true}
                            isClearable={true}
                            value={listaIconos.find(e => e.value === pregunta.valueUrlIcon)}
                            onChange={(event) => {
                                handlePreguntaIcon(indexSeccion, indexPregunta, event);
                            }}
                            placeholder="Seleccione Icono"
                        />
                        <div
                            style={{
                                height: "8px",
                            }}
                        ></div>
                        {pregunta.urlIcon !== null &&
                            <div className="flex justify-end" >
                                <img src={pregunta.urlIcon} width={48} height={48} />
                            </div>
                        }
                    </div>
                    <div
                        style={{
                            width: "1%",
                        }}
                    ></div>
                    <div style={{
                        width: "70%",
                        flexDirection: "column",
                        display: "flex",
                    }}
                    >
                        <input
                            id="tituloPregunta"
                            name="tituloPregunta"
                            type="text"
                            value={pregunta.tituloPregunta}
                            onChange={e => handleInputChangePregunta(e, indexSeccion, indexPregunta)}
                            className={ESTILO_INPUT_GENERICO}
                            required
                            maxLength={255}
                            placeholder="TITULO PREGUNTA"
                        />
                        <div
                            style={{
                                height: "8px",
                            }}
                        ></div>
                        <div
                            style={{
                                width: "50%",
                            }}
                        >
                            <Select
                                options={listaOpcionesRespuesta}
                                isSearchable={true}
                                isClearable={true}
                                value={null}
                                onChange={(event) => {
                                    handleOpcionesRespuesta(indexSeccion, indexPregunta, event);
                                }}
                                placeholder="Seleccione Opcion Respuesta"
                            /></div>
                        <div
                            style={{
                                height: "8px",
                            }}
                        ></div>
                        {pregunta.opcionesRespuestasHabilitadas !== null &&
                            <div>
                                <label className="font-bold">{t('label_orientacion_opciones_respuesta')}</label>
                                <div className="flex flex-row space-x-2">
                                    <SwitchComponent
                                        isOn={pregunta.orientacionRespuestas === INT_ORIENTACION_RESPUESTAS.HORIZONTAL}
                                        handleToggle={() => {
                                            // console.log(indexSeccion, indexPregunta);
                                            let listaSeccionTemp = [...listaSecciones];
                                            listaSeccionTemp[indexSeccion].preguntas[indexPregunta].orientacionRespuestas = pregunta.orientacionRespuestas === INT_ORIENTACION_RESPUESTAS.HORIZONTAL ? INT_ORIENTACION_RESPUESTAS.VERTICAL : INT_ORIENTACION_RESPUESTAS.HORIZONTAL;
                                            setListaSecciones(listaSeccionTemp);
                                        }}
                                    />
                                    <label>{pregunta.orientacionRespuestas === INT_ORIENTACION_RESPUESTAS.HORIZONTAL ? 'Horizontal' : 'Vertical'}</label>
                                </div>
                                <div>
                                    <label className="font-bold">{t('label_opciones_respuesta_habilitadas')}</label>
                                    {renderOpcionesRespuestaHabilitadas(indexSeccion, indexPregunta, pregunta)}
                                </div>
                            </div>
                        }
                        <div
                            style={{
                                height: "8px",
                            }}
                        ></div>
                        {pregunta.opcionesRespuestasDeshabilitadas !== null &&
                            <div>
                                <label className="font-bold">{t('label_opciones_respuesta_deshabilitadas')}</label>
                                {renderOpcionesRespuestaDeshabilitadas(indexSeccion, indexPregunta, pregunta)}
                            </div>
                        }
                        <div
                            style={{
                                height: "8px",
                            }}
                        ></div>
                    </div>
                </>
            );
        } catch (error) {
            console.log('renderRowIconoPregunta err');
            console.log(error);
            return (
                <div>
                    <label>ERROR</label>
                </div>
            );
        }
    };

    const renderOpcionesRespuestaHabilitadas = (indexSeccion, indexPregunta, pregunta) => {
        try {
            // console.log('renderOpcionesRespuestaHabilitadas');
            // console.log('listaSecciones');
            // console.log(listaSecciones);
            // console.log('indexSeccion');
            // console.log(indexSeccion);
            // console.log('indexPregunta');
            // console.log(indexPregunta);
            // console.log('pregunta');
            // console.log(pregunta);
            return (
                <div className="flex flex-row space-x-2">
                    {listaSecciones[indexSeccion].preguntas[indexPregunta].opcionesRespuestasHabilitadas.map((element, indexOpcionRespuesta) => (
                        <span className="flex items-center bg-gray-200 p-2 rounded">
                            {element.label}
                            <XSquare title={t("label_eliminar_opcion_respuesta")} className="ml-2 cursor-pointer"
                                onClick={() => {
                                    eliminarOpcionRespuesta(indexSeccion, indexPregunta, indexOpcionRespuesta, element);
                                }}
                            />
                        </span>
                    ))}
                </div>
            );

        } catch (err) {
            console.log('renderOpcionesRespuestaHabilitadas err');
            console.log(err);
        }
    };

    const renderOpcionesRespuestaDeshabilitadas = (indexSeccion, indexPregunta, pregunta) => {
        try {
            return (
                <div className="flex flex-row space-x-2">
                    {listaSecciones[indexSeccion].preguntas[indexPregunta].opcionesRespuestasDeshabilitadas.map((element, indexOpcionRespuesta) => (
                        <span className="flex items-center bg-gray-200 p-2 rounded">
                            {element.label}
                            <CheckSquare title={t("label_restaurar_opcion_respuesta")} className="ml-2 cursor-pointer"
                                onClick={() => {
                                    restaurarOpcionRespuesta(indexSeccion, indexPregunta, indexOpcionRespuesta, element);
                                }}
                            />
                        </span>
                    ))}
                </div>
            );
        } catch (err) {
            console.log('renderOpcionesRespuestaDeshabilitadas err');
            console.log(err);
        }
    };

    const renderPreguntaFirma = (indexSeccion, pregunta, indexPregunta, arrowStyle, styleRow) => {
        try {
            return renderPreguntaSinOpcionRespuesta(indexSeccion, pregunta, indexPregunta, t('titulo_firma'), arrowStyle, styleRow);
        } catch (err) {
            console.log('renderPreguntaFirma err');
            console.log(err);
        }
    };

    const renderPreguntaImagen = (indexSeccion, pregunta, indexPregunta, arrowStyle, styleRow) => {
        try {
            return renderPreguntaSinOpcionRespuesta(indexSeccion, pregunta, indexPregunta, t('titulo_imagen'), arrowStyle, styleRow);
        } catch (err) {
            console.log('renderPreguntaImagen err');
            console.log(err);
        }
    };

    const renderPreguntaComentario = (indexSeccion, pregunta, indexPregunta, arrowStyle, styleRow) => {
        try {
            return renderPreguntaSinOpcionRespuesta(indexSeccion, pregunta, indexPregunta, t('titulo_comentario'), arrowStyle, styleRow);
        } catch (err) {
            console.log('renderPreguntaComentario err');
            console.log(err);
        }
    };

    const renderPreguntaSinOpcionRespuesta = (indexSeccion, pregunta, indexPregunta, placeHolder, arrowStyle, styleRow) => {
        try {
            if (pregunta.query === INT_QUERY_UPDATE) {
                return (
                    <div
                        style={styleRow}
                    >
                        <hr />
                        {renderUpDownButton(arrowStyle, indexSeccion, indexPregunta)}
                        <div
                            style={{
                                width: '90%'
                            }}
                        >
                            <div className="flex flex-row w-full pt-2" >
                                <div style={{
                                    width: "30%",
                                }}
                                >
                                    <span className="font-bold">{t('label_tipo_pregunta')}: </span>
                                    <span>{pregunta.tipo}</span>
                                </div>
                                <div className="flex flex-row w-full" >
                                    <div style={{
                                        width: "70%",
                                    }}
                                    >
                                        <input
                                            id="tituloPregunta"
                                            name="tituloPregunta"
                                            type="text"
                                            value={pregunta.tituloPregunta}
                                            onChange={e => handleInputChangePregunta(e, indexSeccion, indexPregunta)}
                                            className={ESTILO_INPUT_GENERICO}
                                            required
                                            maxLength={255}
                                            placeholder={placeHolder}
                                        />
                                    </div>
                                </div>
                            </div>

                            <FooterPregunta
                                indexPregunta={indexPregunta}
                                indexSeccion={indexSeccion}
                                handleEliminarPregunta={handleEliminarPregunta}
                            />
                        </div>
                    </div>
                );
            }
            return (<div></div>);
        } catch (err) {
            console.log('renderPreguntaSinOpcionRespuesta err');
            console.log(err);
            return (
                <div>
                    <label>ERROR</label>
                </div>
            );
        }
    };

    const renderUpDownButtonSecciones = (indexSeccion) => {
        return (
            <div
                style={{ display: 'flex', flexDirection: 'row' }}
            >
                {indexSeccion > 0 &&
                    <button
                        type="button"
                        className={ESTILO_SECCION_BOTON_UP}
                        onClick={() => { moverSeccionUpClick(indexSeccion); }}
                        title={t("label_mover_seccion_arriba")}
                    >
                        <ArrowUpCircle />
                    </button>
                }
                {indexSeccion < listaSecciones.length - 1 &&
                    <button
                        type="button"
                        className={ESTILO_SECCION_BOTON_DOWN}
                        onClick={() => { moverSeccionDownClick(indexSeccion); }}
                        title={t("label_mover_seccion_abajo")}
                    >
                        <ArrowDownCircle />
                    </button>}
            </div>
        );
    };

    const moverSeccionUpClick = (indexSeccion) => {
        if (indexSeccion === 0) return; // No mover si es el primer elemento        
        setListaSecciones((prevItems) => {
            const newItems = [...prevItems];
            [newItems[indexSeccion - 1], newItems[indexSeccion]] = [newItems[indexSeccion], newItems[indexSeccion - 1]];
            return newItems;
        });
    };

    const moverSeccionDownClick = (indexSeccion) => {
        if (indexSeccion === listaSecciones.length - 1) return; // No mover si es el último elemento
        setListaSecciones((prevItems) => {
            const newItems = [...prevItems];
            [newItems[indexSeccion + 1], newItems[indexSeccion]] = [newItems[indexSeccion], newItems[indexSeccion + 1]];
            return newItems;
        });
    };

    const renderUpDownButton = (arrowStyle, indexSeccion, indexPregunta) => {
        return (
            <div
                style={arrowStyle}
            >
                {indexPregunta > 0 &&
                    <button
                        type="button"
                        className={ESTILO_BOTON_UP}
                        onClick={() => { movePreguntaUpClick(indexPregunta, indexSeccion); }}
                        title={t('label_mover_arriba')}
                    >
                        <ArrowUpCircle />
                    </button>
                }
                <div style={{ height: 10 }}></div>
                {indexPregunta < listaSecciones[indexSeccion].preguntas.length - 1 &&
                    <button
                        type="button"
                        className={ESTILO_BOTON_DOWN}
                        onClick={() => { movePreguntaDownClick(indexPregunta, indexSeccion); }}
                        title={t('label_mover_abajo')}
                    >
                        <ArrowDownCircle />
                    </button>}
            </div>
        );
    };

    const movePreguntaUpClick = (indexPregunta, indexSeccion) => {
        if (indexPregunta === 0) return; // No mover si es el primer elemento        
        setListaSecciones((prevItems) => {
            const newItems = [...prevItems];
            const updatedSeccion = { ...newItems[indexSeccion] };
            const updatedPreguntas = [...updatedSeccion.preguntas];
            [updatedPreguntas[indexPregunta - 1], updatedPreguntas[indexPregunta]] = [updatedPreguntas[indexPregunta], updatedPreguntas[indexPregunta - 1]];
            updatedSeccion.preguntas = updatedPreguntas;
            newItems[indexSeccion] = updatedSeccion;
            return newItems;
        });

    };

    const movePreguntaDownClick = (indexPregunta, indexSeccion) => {
        if (indexPregunta === listaSecciones[indexSeccion].preguntas.length - 1) return; // No mover si es el último elemento
        setListaSecciones((prevItems) => {
            const newItems = [...prevItems];
            const updatedSeccion = { ...newItems[indexSeccion] };
            const updatedPreguntas = [...updatedSeccion.preguntas];
            [updatedPreguntas[indexPregunta + 1], updatedPreguntas[indexPregunta]] = [updatedPreguntas[indexPregunta], updatedPreguntas[indexPregunta + 1]];
            updatedSeccion.preguntas = updatedPreguntas;
            newItems[indexSeccion] = updatedSeccion;
            return newItems;
        });
    };

    const handleEliminarSeccion = (indexSeccion) => {
        console.log('indexSeccion');
        console.log(indexSeccion);
        const userConfirmed = window.confirm(t('alert_confirma_deshabilitar_seccion_nro') + ' ' + (parseInt(indexSeccion)));
        if (userConfirmed) {
            let newListaSecciones = [...listaSecciones];
            newListaSecciones[indexSeccion].query = INT_QUERY_DELETE;
            setListaSecciones(newListaSecciones);
        }
    };

    const handleEliminarPregunta = (indexSeccion, indexPregunta) => {
        console.log('handleEliminarPregunta');
        // console.log('listaSecciones');
        // console.log(listaSecciones);
        // console.log('indexSeccion');
        // console.log(indexSeccion);
        // console.log('indexPregunta');
        // console.log(indexPregunta);
        console.log('/////////**********////////');
        console.log(listaSecciones[indexSeccion].preguntas[indexPregunta]);
        const userConfirmed = window.confirm(t('alert_confirma_deshabilitar_pregunta_nro') + ' ' + (parseInt(indexPregunta)) + ' ' + t('label_seccion_nro') + ': ' + (parseInt(indexSeccion)));
        // console.log('userConfirmed');
        // console.log(userConfirmed);
        if (userConfirmed) {
            let newListaSecciones = [...listaSecciones];
            newListaSecciones[indexSeccion].preguntas[indexPregunta].query = INT_QUERY_DELETE;
            setListaSecciones(newListaSecciones);
        }
    };

    const handlePreguntaIcon = (indexSeccion, indexPregunta, event) => {
        try {
            // console.log('handlePreguntaIcon');
            // console.log('listaSecciones');
            // console.log(listaSecciones);
            // console.log('indexSeccion');
            // console.log(indexSeccion);
            // console.log('indexPregunta');
            // console.log(indexPregunta);
            // console.log('event');
            // console.log(event);
            let newListaSecciones = [...listaSecciones];
            if (event !== null) {
                newListaSecciones[indexSeccion].preguntas[indexPregunta].urlIcon = event.url;
                newListaSecciones[indexSeccion].preguntas[indexPregunta].valueUrlIcon = event.value;
            }
            if (event === null) {
                newListaSecciones[indexSeccion].preguntas[indexPregunta].urlIcon = null;
                newListaSecciones[indexSeccion].preguntas[indexPregunta].valueUrlIcon = null;
            }
            setListaSecciones(newListaSecciones);
            // console.log('newListaSecciones');
            // console.log(newListaSecciones);
        } catch (err) {
            console.log('handlePreguntaIcon err');
            console.log(err);
        }
    };

    const handleOpcionesRespuesta = async (indexSeccion, indexPregunta, event) => {
        try {
            // console.log('handleOpcionesRespuesta');
            // console.log('checklistSelected');
            // console.log(checklistSelected);
            // console.log('listaSecciones');
            // console.log(listaSecciones);
            // console.log('indexSeccion');
            // console.log(indexSeccion);
            // console.log('indexPregunta');
            // console.log(indexPregunta);
            // console.log('event');
            // console.log(event);
            // console.log('/////////**********////////');
            let newListaSecciones = [...listaSecciones];
            if (event !== null) {
                const existeHabilitado = newListaSecciones[indexSeccion].preguntas[indexPregunta].opcionesRespuestasHabilitadas.find(e => e.value === event.value);
                const existeDeshabilitado = newListaSecciones[indexSeccion].preguntas[indexPregunta].opcionesRespuestasDeshabilitadas.find(e => e.value === event.value);
                if (existeHabilitado === undefined && existeDeshabilitado === undefined) {
                    let objEnviar = {};
                    objEnviar.idChecklist = checklistSelected.id;
                    objEnviar.idSeccion = listaSecciones[indexSeccion].id;
                    objEnviar.idPreguntaSeccion = listaSecciones[indexSeccion].preguntas[indexPregunta].id;
                    objEnviar.idOpcionRespuesta = event.value;
                    const guardarOpcionRespuesta = await guardarOpcionRespuestaPregunta(objEnviar);
                    // console.log('guardarOpcionRespuesta');
                    // console.log(guardarOpcionRespuesta);
                    if (guardarOpcionRespuesta.creado === true) {
                        event.idBase = guardarOpcionRespuesta.id;
                        newListaSecciones[indexSeccion].preguntas[indexPregunta].opcionesRespuestasHabilitadas.push(event);
                    }
                    if (guardarOpcionRespuesta.creado === false) {
                        alert(t('alert_no_se_pudo_agregar_opcion_respuesta_intente_nuevamente'));
                    }
                } else {
                    alert(t('alert_asegurese_que_su_opcion_respuesta_seleccionada_no_se_encuentre_en_opciones_respuesta_habilitadas_deshabilitadas'));
                }
            }
            setListaSecciones(newListaSecciones);
            // console.log('newListaSecciones');
            // console.log(newListaSecciones);
        } catch (err) {
            console.log('handleOpcionesRespuesta err');
            console.log(err);
        }
    };

    const eliminarOpcionRespuesta = async (indexSeccion, indexPregunta, indexOpcionRespuesta, element) => {
        try {
            // console.log('eliminarOpcionRespuesta');
            // console.log('listaSecciones');
            // console.log(listaSecciones);
            // console.log('indexSeccion');
            // console.log(indexSeccion);
            // console.log('indexPregunta');
            // console.log(indexPregunta);
            // console.log('indexOpcionRespuesta');
            // console.log(indexOpcionRespuesta);
            // console.log('element');
            // console.log(element);
            const userConfirmed = window.confirm(t('alert_confirma_deshabilitar_opcion_respuesta_nro') + ': \n' + element.label);
            // console.log('userConfirmed');
            // console.log(userConfirmed);
            if (userConfirmed) {
                let newListaSecciones = [...listaSecciones];
                const deshabilitado = await deshabilitarOpcionRespuestaPregunta({ id: element.idBase });
                if (deshabilitado === true) {
                    newListaSecciones[indexSeccion].preguntas[indexPregunta].opcionesRespuestasHabilitadas = newListaSecciones[indexSeccion].preguntas[indexPregunta].opcionesRespuestasHabilitadas.filter(e => e.idBase !== element.idBase);
                    newListaSecciones[indexSeccion].preguntas[indexPregunta].opcionesRespuestasDeshabilitadas.push(element);
                    setListaSecciones(newListaSecciones);
                    alert(t('alert_se_deshabilito_correctamente'));
                }
                if (deshabilitado === false) {
                    alert(t('alert_no_se_pudo_deshabilitar_opcion_respuesta_intente_nuevamente'));
                }
                setListaSecciones(newListaSecciones);
            }
        } catch (err) {
            console.log('eliminarOpcionRespuesta err');
            console.log(err);
        }
    };

    const restaurarOpcionRespuesta = async (indexSeccion, indexPregunta, indexOpcionRespuesta, element) => {
        try {
            // console.log('restaurarOpcionRespuesta');
            // console.log('indexSeccion');
            // console.log(indexSeccion);
            // console.log('indexPregunta');
            // console.log(indexPregunta);
            // console.log('indexOpcionRespuesta');
            // console.log(indexOpcionRespuesta);
            // console.log('element');
            // console.log(element);
            const userConfirmed = window.confirm(t('alert_confirma_restaurar_opcion_respuesta_nro') + ': \n' + element.label);
            // console.log('userConfirmed');
            // console.log(userConfirmed);
            if (userConfirmed) {
                let newListaSecciones = [...listaSecciones];
                const restaurar = await restaurarOpcionRespuestaPregunta({ id: element.idBase });
                if (restaurar === true) {
                    newListaSecciones[indexSeccion].preguntas[indexPregunta].opcionesRespuestasDeshabilitadas = newListaSecciones[indexSeccion].preguntas[indexPregunta].opcionesRespuestasDeshabilitadas.filter(e => e.idBase !== element.idBase);
                    newListaSecciones[indexSeccion].preguntas[indexPregunta].opcionesRespuestasHabilitadas.push(element);
                    setListaSecciones(newListaSecciones);
                    alert(t('alert_se_restauro_correctamente'));
                }
                if (restaurar === false) {
                    alert(t('alert_no_se_pudo_restaurar_opcion_respuesta_intente_nuevamente'));
                }
                setListaSecciones(newListaSecciones);
            }
        } catch (err) {
            console.log('restaurarOpcionRespuesta err');
            console.log(err);
        }
    };

    const validarSeccion = () => {
        try {
            let error = "";
            for (let i = 0; i < listaSecciones.length; i++) {
                const element = listaSecciones[i];
                if (element.query === INT_QUERY_UPDATE) {
                    if (element.nombreSeccion === undefined || element.nombreSeccion === null || String(element.nombreSeccion).trim().length === 0) {
                        error = error + t('label_seccion_nro') + ': ' + (i).toString() + ' ' + t('label_no_tiene_nombre_seccion') + ' \n';
                    }
                }
            }
            if (String(error).length === 0) {
                return true;
            }
            alert(error);
            return false;
        } catch (err) {
            console.log('validarSeccion err');
            console.log(err);
            return false;
        }
    };

    const validarPreguntas = () => {
        try {
            let error = "";
            for (let i = 0; i < listaSecciones.length; i++) {
                const element = listaSecciones[i];
                if (element.query === INT_QUERY_UPDATE && element.preguntas !== undefined) {
                    for (let k = 0; k < element.preguntas.length; k++) {
                        const pregunta = element.preguntas[k];
                        if (pregunta.query === INT_QUERY_UPDATE) {
                            if (pregunta.tituloPregunta === undefined || pregunta.tituloPregunta === null || String(pregunta.tituloPregunta).trim().length === 0) {
                                error = error + t('label_seccion_nro') + ': ' + (i).toString() + ' ' + t('label_numero_pregunta') + ': ' + (k).toString() + ' ' + t('label_no_tiene_titulo_pregunta_descripcion') + ' \n';
                            }
                            if (pregunta.idTipo === INT_PREGUNTA_SELECCION_MULTIPLE || pregunta.idTipo === INT_PREGUNTA_SELECCION_SIMPLE) {
                                if (pregunta.opcionesRespuestasHabilitadas.length === 0) {
                                    error = error + t('label_seccion_nro') + ': ' + (i).toString() + ' ' + t('label_numero_pregunta') + ': ' + (k).toString() + ' ' + t('label_no_tiene_opciones_respuesta') + ' \n';
                                }
                            }
                        }
                    }
                }
            }
            if (String(error).length === 0) {
                return true;
            }
            alert(error);
            return false;
        } catch (err) {
            console.log('validarPreguntas err');
            console.log(err);
            return false;
        }
    };

    const onPressGuardarPreguntas = async () => {
        try {
            // console.log('onPressGuardarPreguntas');
            // console.log(listaSecciones);
            const seccionesValidas = validarSeccion();
            if (seccionesValidas === false) {
                return;
            }
            const preguntasValidas = validarPreguntas();
            if (preguntasValidas === false) {
                return;
            }
            for (let indexSeccion = 0; indexSeccion < listaSecciones.length; indexSeccion++) {
                listaSecciones[indexSeccion].orden = indexSeccion;
                for (let indexPregunta = 0; indexPregunta < listaSecciones[indexSeccion].preguntas.length; indexPregunta++) {
                    listaSecciones[indexSeccion].preguntas[indexPregunta].orden = indexPregunta;
                }
            }
            let objEnviar = {};
            objEnviar.checklistSelected = checklistSelected;
            objEnviar.listaSecciones = listaSecciones;
            // objEnviar.manejoDefensivo = manejoDefensivo;
            const actualizado = await actualizarPreguntasChecklist(objEnviar);
            // console.log("actualizado");
            // console.log(actualizado);
            if (actualizado === true) {
                alert(t('alert_procesado_correctamente'));
                handleAtrasClick();
            }
            if (actualizado === false) {
                alert(t('alert_no_se_pudo_procesar_intente_nuevamente'));
            }
        } catch (err) {
            console.log('onPressGuardarPreguntas err');
            console.log(err);
        }
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (noContent === true) {
                return (
                    <div className="flex justify-between pl-4 pr-4 items-center">
                        {NoContentCard()}
                        <button
                            type="button"
                            className={ESTILO_BOTON_LISTAR_ATRAS}
                            onClick={handleAtrasClick}
                        >
                            {t('btn_atras')}
                        </button>
                    </div>
                );
            }
            return (
                <div className="pl-4 pr-4">
                    <div className="flex justify-between items-center">
                        <div className="flex justify-center align-center">
                            <span>
                                {t('titulo_preguntas_checklist')}
                            </span>
                            <label
                                style={{
                                    paddingLeft: 10,
                                    fontWeight: 'bold',
                                }}
                            >
                                {checklistSelected.descripcion}
                            </label>
                        </div>
                        <div className="flex justify-center">
                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={handleAtrasClick}
                                onMouseEnter={() => setIsHoveredBackButton(true)}
                                onMouseLeave={() => setIsHoveredBackButton(false)}
                            >
                                {isHoveredBackButton ? (
                                    <ChevronsLeft className="mr-2 transition-transform duration-500 ease-in-out" />
                                ) : (
                                    <ChevronLeft className="mr-2 transition-transform duration-500 ease-in-out" />
                                )}
                                {t('btn_atras')}
                            </button>
                        </div>
                    </div>
                    <hr />
                    <br />
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3">
                            <div className="flex items-center">
                                <span className="text-red-500 font-bold">*</span>
                                <label className="font-bold ml-1">{t('label_nombre_checklist')}</label>
                            </div>
                            <input
                                id="nombre"
                                name="nombre"
                                type="text"
                                value={checklistSelected.nombre}
                                onChange={handleInputChange}
                                className={ESTILO_INPUT_GENERICO}
                                required
                                maxLength={255}
                            />
                        </div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3">
                            <label className="font-bold">{t('label_tipo_checklist')}</label>
                            <Select
                                options={listaTipoChecklist}
                                isSearchable={true}
                                isClearable={true}
                                value={tipoChecklistSelected}
                                onChange={(e) => {
                                    setTipoChecklistSelected(e);
                                }}
                                placeholder={t('label_seleccione_tipo_checklist')}
                            />
                        </div>
                    </div>
                    <br />
                    <div class="grid grid-cols-12 gap-4 items-center">
                        <div class="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
                            <label className="font-bold">{t('label_nota')}</label>
                            <textarea
                                id="nota"
                                name="nota"
                                type="text"
                                value={checklistSelected.nota}
                                onChange={handleInputChange}
                                className={ESTILO_INPUT_GENERICO}
                                required
                                maxLength={2047}
                            />
                        </div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6 flex justify-end">
                            <button
                                className={ESTILO_BOTON_MODAL_ACEPTAR}
                                onClick={onPressActualizar}
                            >
                                <RefreshCcw className={`mr-2 ${ESTILO_ROTATE_180}`} />
                                {t('btn_actualizar')}
                            </button>
                        </div>
                    </div>
                    <br />
                    <hr />
                    <div className="flex flex-row items-center">
                        <h2 className="mr-2 font-bold">{t('label_seccion')}</h2>
                        <button
                            className={`${ESTILO_BOTON_GENERAL_ACEPTAR} flex items-center`}
                            title="AGREGAR SECCION"
                            onClick={() => { handleAddSection(); }}
                        >
                            <Plus className={`mr-2 ${ESTILO_ROTATE_180}`} />
                            {t('btn_nueva_seccion')}
                        </button>
                    </div>
                    <br />
                    <div>
                        {renderSections()}
                    </div>
                    <div className="flex flex-row justify-end mb-8">
                        <button
                            className={`${ESTILO_BOTON_MODAL_ACEPTAR} flex items-center`}
                            onClick={() => { onPressGuardarPreguntas(); }}
                            title={t('titulo_guardar_preguntas')}
                        >
                            <Save className="mr-2" />
                            {t('btn_guardar_preguntas')}
                        </button>
                    </div>
                </div>
            );
        } catch (err) {
            console.log('render err dashboard');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    };

    return render();
}
/*
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-6 bg-gray-200 p-4">Column 1</div>
                        <div class="col-span-6 bg-gray-300 p-4">Column 2</div>
                        <div class="col-span-6 bg-gray-400 p-4">Column 3</div>
                        <div class="col-span-6 bg-gray-500 p-4">Column 4</div>
                    </div>
                    <br />
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12 md:col-span-6 lg:col-span-4 bg-gray-200 p-4">Column 1</div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-4 bg-gray-300 p-4">Column 2</div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-4 bg-gray-400 p-4">Column 3</div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-4 bg-gray-500 p-4">Column 4</div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-4 bg-gray-600 p-4">Column 5</div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-4 bg-gray-700 p-4">Column 6</div>
                    </div>
                    <br />
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2 bg-gray-200 p-4">Column 1</div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2 bg-gray-300 p-4">Column 2</div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2 bg-gray-400 p-4">Column 3</div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2 bg-gray-500 p-4">Column 4</div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2 bg-gray-600 p-4">Column 5</div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2 bg-gray-700 p-4">Column 6</div>
                    </div>
                    */